import React from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import { TTemplate } from "../../../../../utils/types";
import { PrimaryButton } from "../../../../common/native";
import Template from "../template/Template";
import { useOnboardingTips } from "../../../../../contexts/OnboardingTipsContext";
import { TOOLTIP_STEPS } from "../../../../../utils/constant";
import {
  RainbowBorder,
  StickyOnboardingModal,
  beforeAfterSteps,
} from "../../../../common/native";

type Step3Props = {
  setStep: (step: number) => void;
  template: TTemplate;
  setTemplateEdit: (template: TTemplate) => void;
  tipsEnabled?: boolean;
};

const Step3: React.FC<Step3Props> = ({
  setStep,
  template,
  setTemplateEdit,
  tipsEnabled = false,
}) => {
  const { tipsState, markStepComplete } = useOnboardingTips();

  return (
    <>
      <ScrollView contentContainerStyle={styles.container}>
        <Template
          template={template}
          displayMode={false}
          swapImagesModalData={null}
          setTemplate={setTemplateEdit}
          tipsEnabled={tipsEnabled}
        />

        <View style={styles.buttonContainer}>
          <RainbowBorder
            isActive={
              tipsEnabled &&
              tipsState.continueToBeforeAfterResults &&
              !tipsState.adjustImages
            }
            borderRadius={12}
          >
            <PrimaryButton
              text="Continue"
              width={200}
              onPress={() => {
                markStepComplete(
                  TOOLTIP_STEPS.CONTINUE_TO_BEFORE_AFTER_RESULTS,
                );
                setStep(4);
              }}
              roundBorderRadius
            />
          </RainbowBorder>
        </View>
      </ScrollView>
      {tipsEnabled && <StickyOnboardingModal steps={beforeAfterSteps} />}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 15,
    paddingBottom: 40,
  },
  buttonContainer: {
    // marginTop: "auto",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 10,
    justifyContent: "center",
  },
  modalContent: {
    width: "100%",
    minHeight: 300,
    padding: 20,
    borderWidth: 1,
    borderColor: "#DDDEE0",
    backgroundColor: "#F8F8F8",
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    alignItems: "center",
  },
  modalContainer: {
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "center",
  },
});

export default Step3;
